/* Kickline cart drawer: cross-sell carousel + add to cart */
const closestEl = (t, sel) => (t instanceof Element ? t.closest(sel) : null);

document.addEventListener('click', (e) => {
  const prev = closestEl(e.target, '[data-kl-xs-prev]');
  const next = closestEl(e.target, '[data-kl-xs-next]');
  if (prev || next) {
    const track = closestEl(e.target, '[data-kl-xs]')?.querySelector('[data-kl-xs-track]');
    if (track) track.scrollBy({ left: (next ? 1 : -1) * track.clientWidth, behavior: 'smooth' });
    return;
  }
  const btn = closestEl(e.target, '[data-kl-xs-add]');
  if (btn) addToCart(btn);
});

document.addEventListener('change', (e) => {
  const sel = closestEl(e.target, '[data-kl-xs-variant]');
  if (!sel) return;
  const card = sel.closest('.kl-xs__card');
  const opt = sel.selectedOptions[0];
  card.querySelector('[data-kl-xs-add]').dataset.variant = sel.value;
  const price = card.querySelector('[data-kl-xs-price]');
  if (price && opt?.dataset.price) price.textContent = opt.dataset.price;
});

async function addToCart(btn) {
  if (btn.disabled) return;
  const variantId = Number(btn.dataset.variant);
  if (!variantId) return;
  const label = btn.textContent;
  btn.disabled = true;
  btn.textContent = 'Adding...';

  let Events = null;
  try {
    Events = await import('@shopify/events');
  } catch (_) {
    Events = null;
  }
  const addUrl = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';

  try {
    const deferred = Events ? Events.CartLinesUpdateEvent.createPromise() : null;
    if (Events) {
      btn.dispatchEvent(
        new Events.CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: [{ merchandiseId: 'gid://shopify/ProductVariant/' + variantId, quantity: 1 }],
          promise: deferred.promise,
        })
      );
    }
    const res = await fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        sections: 'cart-drawer-section',
        sections_url: window.location.pathname,
      }),
    }).then((r) => r.json());
    if (res.status) {
      if (deferred) deferred.reject(new Error(res.message || 'Add to cart failed'));
      throw new Error(res.message || 'Add to cart failed');
    }
    const cartUrl = (window.Theme && Theme.routes && Theme.routes.cart_url) || '/cart';
    const ajaxCart = await fetch(cartUrl + '.json', { headers: { Accept: 'application/json' } }).then((r) => r.json());
    if (deferred) {
      deferred.resolve({
        cart: Events.CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
        detail: {
          items: ajaxCart.items,
          source: 'kl-cross-sell',
          sourceId: 'kl-cross-sell',
          itemCount: 1,
          productId: btn.dataset.product,
          sections: res.sections,
          didError: false,
        },
      });
    } else {
      window.location.reload();
    }
  } catch (err) {
    console.warn('[kickline] cross-sell add failed', err);
    btn.disabled = false;
    btn.textContent = label;
  }
}
